module.exports = __webpack_public_path__ + "img/caixa-mila.5699c91c.jpg";